module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.quoteData.elements) ? _c('section', {
    staticClass: "content-quote container-fluid col-xs-12"
  }, [(_vm.quoteData.elements.quote_text) ? _c('div', {
    staticClass: "quote-text text-center"
  }, [_vm._v("\n\t\t\t\"" + _vm._s(_vm.quoteData.elements.quote_text.value) + "\"\n\n\t\t\t"), (_vm.quoteData.elements.author) ? _c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.quoteData.elements.author.value) + " ")]) : _vm._e()]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-162b21ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quote.vue
// module id = 1503
// module chunks = 0